import React, { useState, useEffect, useReducer } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
// import Table from "core/pagination/datatable";
import { Table } from "antd";
import TableTop from "Components/UI/TableTop";
import Loader from "feature-module/loader/loader";
import { useTableSearch } from "core/Operations/useTableSearch";
import {
  Edit,
  PlusCircle,
  Users,
  Save,
  Filter,
} from "feather-icons-react/build/IconComponents";
import Error404 from "MainPages/ErrorPages/error404";
import { useForm, Controller } from "react-hook-form";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import ToastNotification from "Components/UI/ToastNotification";
import { yupResolver } from "@hookform/resolvers/yup";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { dayAttendanceValidationSchema } from "core/Operations/ValidationSchema/attendanceValidationSchema";
import { useAddAttendanceMutation } from "AppQuries/attendance/add-attendance";
import dayjs from "dayjs";
import { DatePicker, TimePicker } from "antd";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import Select from "react-select";
const options = [
  { id: 0, label: "Absent", value: 0 },
  // { id: 1, label: "Half Day", value: 0.5 },
  { id: 2, label: "Present", value: 1 },
];

const DayAttendance = () => {
  const userData = useSelector(loggedInUser);
  const [attendanceFilterDate, setAttendanceFilterDate] = useState(
    format(new Date(), "yyyy-MM-dd")
  );

  const {
    data: employeesData,
    isError,
    isFetching,
    isLoading,
    error,
  } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
  });
  const navigate = useNavigate();
  const [employeeAttendanceList, setEmployeeAttendanceList] = useState([]);

  const {
    register,
    watch,
    getValues,
    setValue,
    control,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      attendanceDate: format(new Date(), "yyyy-MM-dd"),
    },
    resolver: yupResolver(dayAttendanceValidationSchema),
  });
  
  const {
    mutate: addAttendance,
    isLoading: addAttendanceLoading,
    isFetching: addAttendanceFetching,
    isError: addAttendanceIsError,
    error: addAttendanceError,
  } = useAddAttendanceMutation();

  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [show, setShow] = useState(false);

  const onSubmit = async (payload) => {
    const attendanceData = {
      companyCode: 1,
      attendanceDate: payload.attendanceDate,
      attendance: payload?.attendance.map((data) => ({
        employeeCode: Number(data.employeeCode),
        attendanceValue: data.attendanceValue,
        inTime: data.inTime,
        outTime: data.outTime,
        createUser: userData.userName,
        createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
          new Date(),
          "HH:mm:ss.SSS"
        )}Z`,
        modifyUser: userData.userName,
        modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
          new Date(),
          "HH:mm:ss.SSS"
        )}Z`,
      })),
    };

    

    addAttendance(attendanceData, {
      onSuccess: (data) => {
    
        if (data[0].response === true) {
          setMessage("Attendance Saved Successfully.");
          setShowSuccessToast(true);
          setSelectedDesignation(null);
          setShow(false);
          setTimeout(() => {
            navigate(`${all_routes.attendance}${all_routes.attendance_filter}`);
          }, 1000);
        } else {
          setMessage(data[0].errorMessage);
          setShowErrorToast(true);
        }
      },
      onError: (error) => {
        setMessage(error.message || "Something went wrong.");
        setShowErrorToast(true);
      },
    });
  };

  const defaultStates = {};

  const leaveHandler = (state, action) => {
    if (action.type === "MARK_PRESENT") {
      if (action.data.isPresent === true) {
        setValue(`attendance[${action.data.id}].attendanceValue`, 1);
        setValue(`attendance[${action.data.id}].inTime`, "10:00");
        setValue(`attendance[${action.data.id}].outTime`, "18:00");
        setValue(`attendance[${action.data.id}].totalHours`, "08:00");
      } else if (action.data.isPresent === false) {
        setValue(`attendance[${action.data.id}].attendanceValue`, 0);
        setValue(`attendance[${action.data.id}].inTime`, "00:00");
        setValue(`attendance[${action.data.id}].outTime`, "00:00");
        setValue(`attendance[${action.data.id}].totalHours`, "00:00");
      }
    } else if (action.type === "INTIME_CHANGE") {
      setValue(`attendance[${action.data.id}].inTime`, action.data.value);
      calculateTotalHours(action.data.id);
    } else if (action.type === "OUTTIME_CHANGE") {
      setValue(`attendance[${action.data.id}].outTime`, action.data.value);
      calculateTotalHours(action.data.id);
    }
  };

  const calculateTotalHours = (id) => {
    const [hours1, minutes1] = getValues(`attendance[${id}].inTime`).split(":");
    const [hours2, minutes2] = getValues(`attendance[${id}].outTime`).split(
      ":"
    );

    const date1 = new Date();
    date1.setHours(hours1);
    date1.setMinutes(minutes1);

    const date2 = new Date();
    date2.setHours(hours2);
    date2.setMinutes(minutes2);

    const diff = date2 - date1;

    const hoursDiff = Math.floor(diff / (1000 * 60 * 60));
    const minutesDiff = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    setValue(`attendance[${id}].totalHours`, `${hoursDiff}:${minutesDiff}`);
  };

  //   const calculateTotalHours = (id) => {
  //     const inTime = watch(`attendance[${id}].inTime`);
  //     const outTime = watch(`attendance[${id}].outTime`);

  //     // Ensure both inTime and outTime are defined
  //     if (!inTime || !outTime) {
  //       setValue(`attendance[${id}].totalHours`, "00:00");
  //       return;
  //     }
  //     const { hours: hours1, minutes: minutes1 } = TimeConvetor(inTime);
  //     const { hours: hours2, minutes: minutes2 } = TimeConvetor(outTime);

  //     const date1 = new Date();
  //     date1.setHours(hours1, minutes1, 0, 0);

  //     const date2 = new Date();
  //     date2.setHours(hours2, minutes2, 0, 0);
  //     const diff = date2 - date1;

  //     // Calculate the difference in hours and minutes
  //     const hoursDiff = Math.floor(diff / (1000 * 60 * 60));
  //     const minutesDiff = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

  //     setValue(
  //       `attendance[${id}].totalHours`,
  //       `${String(hoursDiff).padStart(2, "0")}:${String(minutesDiff).padStart(
  //         2,
  //         "0"
  //       )}`
  //     );
  //   };

  const [leaveState, dispatch] = useReducer(leaveHandler, defaultStates);

  const onChange = (time, timeString) => {
    
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowErrorToast(false);
      setShowSuccessToast(false);
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [showErrorToast, showSuccessToast]);

  useEffect(() => {
    const empAttendanceData =
      employeesData
        .filter((d) => d.isActive === true)
        .map((data, _id) => {
          setValue(`attendance[${_id}]['employeeCode']`, data.employeeCode);
          setValue(`attendance[${_id}]['isPresent']`, true);
          setValue(`attendance[${_id}]['attendanceValue']`, 1);
          setValue(`attendance[${_id}]['inTime']`, "10:00");
          setValue(`attendance[${_id}]['outTime']`, "18:00");
          setValue(`attendance[${_id}]['totalHours']`, "08:00");
          return {
            id: _id,
            employeeCode: data.employeeCode,
            fullName: data.fullName,
            isPresent: true,
            attendanceValue: 1,
            inTime: "10:00",
            outTime: "18:00",
            totalHours: "08:00",
          };
        }) || [];

    setEmployeeAttendanceList(empAttendanceData);
  }, [employeesData]);

  const columns = [
    {
      title: "Code",
      dataIndex: "employeeCode",
      sorter: (a, b) => a.employeeCode.length - b.employeeCode.length,
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
      sorter: (a, b) => a.fullName.length - b.fullName.length,
    },
    {
      title: "Present",
      render: (text, record) => (
        <>
          <input
            // {...register(`attendance[${record.id}]['isPresent']`)}
            type="checkbox"
            defaultChecked={true}
            onClick={(e) => {
              dispatch({
                type: "MARK_PRESENT",
                data: {
                  id: record.id,
                  isPresent: e.target.checked,
                },
              });
            }}
          />
        </>
      ),
    },
    {
      title: "Attendance Value",
      dataIndex: "attendanceValue",
      render: (text, record) => (
        <>
          <Controller
            name="attendanceValue"
            control={control}
            defaultValue={text}
            render={({ field }) => (
              <Select
                {...field}
                value={options.find((option) => option.value === field.value)}
                className={`select ${
                  errors?.attendanceValue ? "is-invalid" : ""
                }`}
                options={options}
                placeholder="Choose attendance value"
                onChange={(selected) => {
                  setValue("attendanceValue", selected.value);
                  trigger("attendanceValue");
                }}
              />
            )}
          />
        </>
      ),
    },
    {
      title: "In Time",
      render: (text, record) => (
        <>
          <Controller
            name={`attendance[${record.id}][inTime]`}
            defaultValue={watch(`attendance[${record.id}][inTime]`)}
            control={control}
            render={({ field }) => (
              <TimePicker
                // use12Hours
                defaultValue={dayjs(
                  watch(`attendance[${record.id}].inTime`),
                  "HH:mm"
                )}
                // className={`form-control ${errors.attendance[`${record.id}`].inTime}` ? 'is-invalid' : ''}
                className={
                  errors?.attendance?.[`${record.id}`]?.inTime
                    ? "is-invalid"
                    : ""
                }
                format="HH:mm"
                onChange={(time, timeString) => {
                  dispatch({
                    type: "INTIME_CHANGE",
                    data: {
                      id: record.id,
                      value: timeString,
                    },
                  });
                }}
              />
            )}
            //   <input
            //     type="time"
            //     {...register(`attendance[${record.id}][inTime]`)}
            //     className="form-control"
            //     defaultValue={watch(`attendance[${record.id}][inTime]`)}
            //     onChange={(e) => {
            //       dispatch({
            //         type: "INTIME_CHANGE",
            //         data: {
            //           id: record.id,
            //           value: e.target.value,
            //         },
            //       });
            //     }}
            //   />
          />
        </>
      ),
    },
    {
      title: "Out TIme",
      render: (text, record) => (
        <>
          {/* <input
            type="time"
            {...register(`attendance[${record.id}][outTime]`)}
            className="form-control"
            defaultValue={watch(`attendance[${record.id}][outTime]`)}
            onChange={(e) => {
              dispatch({
                type: "OUTTIME_CHANGE",
                data: {
                  id: record.id,
                  value: e.target.value,
                },
              });
            }}
          /> */}

          <Controller
            name={`attendance[${record.id}][outTime]`}
            defaultValue={watch(`attendance[${record.id}][outTime]`)}
            control={control}
            render={({ field }) => (
              <TimePicker
                // use12Hours
                defaultValue={dayjs(
                  watch(`attendance[${record.id}].outTime`),
                  "HH:mm"
                )}
                className={
                  errors?.attendance?.[`${record.id}`]?.outTime
                    ? "is-invalid"
                    : ""
                }
                format="HH:mm"
                onChange={(time, timeString) => {
                  dispatch({
                    type: "OUTTIME_CHANGE",
                    data: {
                      id: record.id,
                      value: timeString,
                    },
                  });
                }}
              />
            )}
          />
        </>
      ),
    },
    {
      title: "Total Hours",
      render: (text, record) => (
        <>
          <input
            type="text"
            {...register(`attendance[${record.id}][totalHours]`)}
            className="form-control"
            readOnly={true}
          />
        </>
      ),
    },
  ];

  if (isLoading || isFetching) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <div>
      <div className="toast-container position-fixed top-0 end-0 p-3">
        <ToastNotification
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          message={message}
        />
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>Attendance Management</h4>
                  <h6>Manage your employees attendance</h6>
                </div>
              </div>
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add Attendance</Tooltip>
                  }
                >
                  <Link
                    to={`${all_routes.attendance}${all_routes.attendance_filter}`}
                    className="btn btn-added"
                    disabled={isFetching || addAttendanceFetching}
                  >
                    <i className="fas fa-reply me-2"></i>
                    Back
                  </Link>
                </OverlayTrigger>
              </div>

              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add Attendance</Tooltip>
                  }
                >
                  <button
                    to={`${all_routes.attendance}${all_routes.attendance_filter}`}
                    className="btn btn-added"
                    type="submit"
                    disabled={isFetching || addAttendanceFetching}
                  >
                    {isFetching || addAttendanceFetching ? (
                      <>
                        <i className="fas fa-spinner fa-spin me-2" /> Loading...
                      </>
                    ) : (
                      <>
                        <Save className="me-2" />
                        Save
                      </>
                    )}
                  </button>
                </OverlayTrigger>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card table-list-card border-0">
                  <div className="card-header">
                    <div className="form-row row">
                      <div className="col-4">
                        <label>
                          Attendance Date<span className="asterisk">*</span>
                        </label>
                        <Controller
                          name="attendanceDate"
                          control={control}
                          defaultValue={watch("attendanceDate")}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              className={`form-control ${
                                errors.attendanceDate ? "is-invalid" : ""
                              }`}
                              placeholder="Select Attendace date"
                              value={
                                field.value
                                  ? dayjs(field.value, "YYYY-MM-DD")
                                  : ""
                              }
                              format="DD-MM-YYYY"
                              onChange={(date) => {
                                setValue(
                                  "attendanceDate",
                                  date ? dayjs(date).format("YYYY-MM-DD") : ""
                                );
                                trigger("attendanceDate");
                              }}
                              getPopupContainer={(trigger) =>
                                trigger.parentNode
                              }
                            />
                          )}
                        />
                        {errors.attendanceDate && (
                          <div className="invalid-feedback">
                            {errors.attendanceDate?.message || "Invalid input"}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <Table
                        className="table datanew"
                        columns={columns}
                        dataSource={employeeAttendanceList}
                        pagination={false}
                      />
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="text-end">
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isFetching || addAttendanceFetching}
                      >
                        {isFetching || addAttendanceFetching ? (
                          <>
                            <i className="fas fa-spinner fa-spin me-2" />
                            Loading...
                          </>
                        ) : (
                          <>
                            <Save className="me-2" />
                            Save Attendance
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DayAttendance;
